import { render, staticRenderFns } from "./bar-chart-v2.vue?vue&type=template&id=4ad020b4&"
import script from "./bar-chart-v2.vue?vue&type=script&lang=js&"
export * from "./bar-chart-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bar-chart-v2.vue"
export default component.exports